// Central error-code → user-facing copy. Raw backend codes must never reach
// the UI; SnackBar and the login page both resolve through this module.
export const ERROR_CODE_MESSAGES: Record<string, string> = {
  // Login flow (backend UserProcessor.verifyStatusPassword + UserBll.adminLogin)
  'usr.prc.une': 'No account was found with that email address.',
  'usr.prc.unr': 'This account has not been confirmed yet. Use the invite link from your email to finish setting it up.',
  'usr.prc.uas': 'This account has been suspended. Please contact your administrator.',
  // LockedOut has no self-service recovery (password reset does not clear it),
  // so the copy must not promise one.
  'usr.prc.ual': 'This account has been locked. Please contact your administrator.',
  'usr.prc.unp': 'Incorrect email or password. Please try again, or use "Forgot Password?" to reset it.',
  // adminLogin throws this as a bare string, not a dotted code: credentials
  // passed but the account has no admin-portal permission. The copy must not
  // confirm the password was correct — that would let an attacker validate
  // credentials against non-admin accounts.
  'No permission to login': 'This account does not have access to the admin portal. Please contact your administrator.',
  // Dead-session codes (axiosService tears the session down and redirects;
  // page-level catches sometimes toast the code during that redirect)
  'usr.aut.iut': 'Your session has expired. Please sign in again.',
  'usr.aut.utm': 'Your session has expired. Please sign in again.',
  'auth.token.missing': 'Your session has expired. Please sign in again.',
  'auth.token.invalid': 'Your session has expired. Please sign in again.',
  'auth.token.expired': 'Your session has expired. Please sign in again.',
}

export const GENERIC_ERROR = 'Something went wrong. Please try again.'

export const AUTH_ERROR_FALLBACK = 'Unable to sign in right now. Please try again.'

// Backend error codes are dotted lowercase tokens (usr.prc.unp,
// auth.token.expired) — never legitimate user-facing copy.
export const isErrorCode = (value: unknown): value is string =>
  typeof value === 'string' && /^[a-z]+(\.[a-z]+){1,4}$/i.test(value)

// axiosService rejects with new Error(code), so the code arrives in
// error.message; the legacy 200+Error-header path rejects with other shapes,
// which land on the fallback.
export const getAuthErrorMessage = (error: unknown): string => {
  const code = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return ERROR_CODE_MESSAGES[code] || AUTH_ERROR_FALLBACK
}
